var map = {
	"./OS_II_ISTANBUL_LOGO-01.webp": 1418,
	"./OS_II_ISTANBUL_LOGO-02.webp": 5302,
	"./bg-1.webp": 8939,
	"./check.svg": 535,
	"./chevron-left.svg": 803,
	"./currencies/bnb.svg": 3897,
	"./currencies/btcb.svg": 5969,
	"./currencies/busd.svg": 654,
	"./currencies/mfi.png": 2211,
	"./currencies/usdc.svg": 5040,
	"./currencies/usdt.svg": 683,
	"./currencies/wbnb.svg": 9163,
	"./currencies/weth.svg": 1803,
	"./dubai-blue.webp": 43,
	"./leaderboard/CheckIcon.svg": 9899,
	"./leaderboard/VIPPlatinumPass.webp": 4899,
	"./leaderboard/XIcon.svg": 143,
	"./leaderboard/congratulations.svg": 6523,
	"./leaderboard/stars_white.svg": 694,
	"./leaderboard/stars_yellow.svg": 2983,
	"./leaderboard/top_1.svg": 9092,
	"./leaderboard/top_100_leaderboard.svg": 5335,
	"./leaderboard/top_2.webp": 417,
	"./leaderboard/top_3.webp": 5759,
	"./level10_no_shadow_to_left.webp": 4470,
	"./metamask_logo.svg": 8792,
	"./metfi.svg": 8798,
	"./nfts/level-0.png": 6977,
	"./nfts/level-m.png": 6116,
	"./nfts/level1.jpg": 456,
	"./nfts/level10.jpg": 7703,
	"./nfts/level2.jpg": 8975,
	"./nfts/level3.jpg": 7030,
	"./nfts/level4.jpg": 3248,
	"./nfts/level5.jpg": 2261,
	"./nfts/level6.jpg": 9042,
	"./nfts/level7.jpg": 9225,
	"./nfts/level8.jpg": 6828,
	"./nfts/level9.jpg": 7464,
	"./ocean-logo.svg": 8171,
	"./red-early-bird.svg": 8074,
	"./tether-logo.webp": 4191,
	"./usdt.svg": 5553,
	"./wallet_connect_logo.svg": 2982,
	"./website-title.svg": 4429,
	"./x.svg": 1275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;